import { useState } from 'react';
import { FolderContent } from '@/api/generatedApi';
import { useBulkModal } from '@/hooks/useBulkModal';
import { TargetFolder } from '@/components/modals/BulkMoveContentsModal/targetFolderUtils';

export const useBulkMoveModal = <T extends FolderContent>({
  selectedRows,
  onClose,
  onComplete,
}: {
  selectedRows: T[];
  onClose: () => void;
  onComplete?: () => void;
}) => {
  const modal = useBulkModal({ selectedRows, onClose });
  const [targetFolder, setTargetFolder] = useState<TargetFolder>();

  const close = () => {
    modal.close();
    setTargetFolder(undefined);
  };

  const handleComplete = () => {
    onComplete?.();
  };

  return { ...modal, close, targetFolder, setTargetFolder, handleComplete };
};
